import { render, staticRenderFns } from "./Vas5Question.vue?vue&type=template&id=252adb1b&scoped=true"
import script from "./Vas5Question.vue?vue&type=script&lang=js"
export * from "./Vas5Question.vue?vue&type=script&lang=js"
import style0 from "./Vas5Question.vue?vue&type=style&index=0&id=252adb1b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "252adb1b",
  null
  
)

export default component.exports